import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Icons } from '../../../shared/helpers/icons';
import { LucideAngularModule } from 'lucide-angular';
import { IStudentInfo } from '../../../shared/models/student';
import { CommonModule } from '@angular/common';
import { DateUtils } from '../../../shared/helpers/dateUtils';
import { EYesNo } from '../../../shared/models/types.enum';

@Component({
  selector: 'student-info',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  templateUrl: './student-info.component.html',
  styleUrl: './student-info.component.css'
})
export class StudentInfoComponent implements OnInit {
  
  icons = Icons;
  yesNo = EYesNo;
  buildingId: string | null = null;  
  student_birthday_to_display: string = '';

  @Input() studentData: IStudentInfo | null = null;
  @Output() onClose = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {
    if (this.studentData) {
      this.student_birthday_to_display = DateUtils.formatDateForDisplay(this.studentData.birthday);
    }
  }

  showYesNo(answer: any): string {
    if (answer === 0) {
      return 'No';
    } else if (answer === 1) {
      return 'Yes';
    } else if (answer === 2) {
      return 'Need More Information';
    } else {
      return 'Invalid';
    }
  }

  handleCloseStudentInfo(): void {
    this.onClose.emit();
  }
}
